import { theme } from '@branchjs/neo-components';
import { css } from '@emotion/css';
import { alpha } from '@mui/material/styles';
import moment from 'moment-timezone';
import { appTimezone } from '../../../main/support/dateUtils';

export const CHARTS_DEFAULTS = {
  QUERY_BUILDER_TITLE: 'Trends',
  INITIAL_DATA_SOURCES: ['eo_open'],
  DATA_NOT_FOUND_TEXT: 'No analytics found. Try adjusting the date range or changing filters.',
  DATA_RETRIEVAL_ERROR_TEXT: 'There was an issue while trying to retrieve your data.',
};

export const CHARTS_DEFAULT_STYLES = {
  trendsContainer: css({
    backgroundColor: theme.colors.primary.contrastWhite,
    borderRadius: '8px',
  }),
  noAnalyticsData: css({
    padding: '50px 0px',
  }),
};

export const CHARTS_DEFAULT_HIGH_CHART_CONFIG = {
  chart: {
    type: 'area',
  },
  plotOptions: {
    series: {
      connectNulls: false,
    },
  },
  time: {
    getTimezoneOffset: function (timestamp) {
      const timezoneOffset = -moment.tz(timestamp, appTimezone).utcOffset();

      return timezoneOffset;
    },
  },
  xAxis: {
    type: 'datetime',
    crosshair: {
      width: 15,
      color: alpha(theme.colors.text[600], 0.05),
      zIndex: 5,
    },
    dateTimeLabelFormats: {
      day: '%m/%d',
    },
    title: {
      enabled: true,
      text: 'Date',
    },
  },
  yAxis: [
    {
      title: {
        enabled: true,
        text: 'Count',
      },
      id: 'axis-default',
    },
    {
      title: {
        enabled: true,
        text: 'Amount',
      },
      labels: {
        formatter: function (this: any) {
          return `$${this.value}`;
        },
      },
      id: 'axis-currency',
      opposite: true,
    },
    {
      title: {
        enabled: true,
        text: 'Amount in local currency',
      },
      labels: {
        formatter: function (this: any) {
          return `$${this.value}`;
        },
      },
      id: 'axis-local-currency',
      opposite: true,
    },
    {
      title: {
        enabled: true,
        text: 'Percentage',
      },
      labels: {
        formatter: function (this: any) {
          return `${this.value.toFixed(1)}%`;
        },
      },
      id: 'axis-percentage',
      opposite: true,
    },
  ],
};
